export default "__VITE_ASSET__02009eaa__"